import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { TextButton, StepItem } from "../Shared";
import * as STEP_KEYS from "../../consts";
import { scheduleSelector } from "../../selectors";
import { toggleControl, getTimeSlotsInPeriod } from "../../actions";
import { deepGet } from "../../../../utils";

class ScheduleSelect extends Component {
  componentDidMount = () => {
    if (this.props.current) {
      const start = moment().add(this.props.earliestBookingTime, "days");
      const end = moment().endOf("month");

      this.props.getTimeSlotsInPeriod(
        start,
        end,
        this.props.availableLocations,
        true,
        this.props.isPhoneConsult
      );
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      this.props.current &&
      (this.props.location !== nextProps.location ||
        this.props.practitioner !== nextProps.practitioner ||
        this.props.timezone !== nextProps.timezone)
    ) {
      const start = moment().add(nextProps.earliestBookingTime, "days");
      const end = moment().endOf("month");
      nextProps.getTimeSlotsInPeriod(
        start,
        end,
        nextProps.availableLocations,
        true,
        nextProps.isPhoneConsult
      );
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      deepGet(this.props.value, ["startDateTime"]) ===
        deepGet(nextProps.value, ["startDateTime"]) &&
      this.props.current === nextProps.current &&
      this.props.placeholder === nextProps.placeholder &&
      this.props.location === nextProps.location
    ) {
      return false;
    }
    return true;
  };

  render() {
    const { hintText, text, reload, placeholder, toggleControl } = this.props;

    return (
      <StepItem>
        {hintText}
        <TextButton
          placeholder={placeholder}
          value={text}
          onClick={() => toggleControl(STEP_KEYS.APPOINTMENT_DATE_TIME, true)}
          reload={!reload}
        />
      </StepItem>
    );
  }
}

export default connect(scheduleSelector, {
  toggleControl,
  getTimeSlotsInPeriod
})(ScheduleSelect);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/ScheduleSelect.js